export default __webpack_public_path__ + "static/media/beneficios3.ef5c324f.png";